import { useMemo } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  template: {
    id: 'AITemplates.typeDisplay.template',
    defaultMessage: 'Template',
  },
  singleReportTemplate: {
    id: 'AITemplates.typeDisplay.singleReportTemplate',
    defaultMessage: 'Single Report Template',
  },
  compositeReportDefinition: {
    id: 'AITemplates.typeDisplay.compositeReportDefinition',
    defaultMessage: 'Composite Report Template',
  },
});

export const useTemplatingItemTypeDisplay = () => {
  const intl = useIntl();

  return useMemo(
    () => ({
      template: intl.formatMessage(messages.template),
      compositeReportDefinition: intl.formatMessage(
        messages.compositeReportDefinition,
      ),
      singleReportTemplate: intl.formatMessage(messages.singleReportTemplate),
    }),
    [intl],
  );
};
